module.exports = __webpack_public_path__ + "static/device_tablet_apple_light_portrait-969a75b88defd4ffa94e17e65a73f857.png";